const BASE_DOMAIN = process.env.VUE_APP_BASE_DOMAIN || "tardstation.com";

const API_ORIGIN = `https://api.${BASE_DOMAIN}`;
const SOCKET_ORIGIN = `https://socket.${BASE_DOMAIN}`;

export const DASHBOARD_API_URL = `${API_ORIGIN}/dashboard-api/v1/`;
export const GENERAL_API_URL = `${API_ORIGIN}/general-api/v1/`;
export const ATTACHMENT_URL = `${GENERAL_API_URL}attachment`;
export const DEFAULT_AVATAR_URL = `${API_ORIGIN}/dashboardAssets/images/cover/cover_sm.png`;
export const SOCKET_URL = SOCKET_ORIGIN;

export default {
  baseDomain: BASE_DOMAIN,
  dashboardApiUrl: DASHBOARD_API_URL,
  generalApiUrl: GENERAL_API_URL,
  attachmentUrl: ATTACHMENT_URL,
  defaultAvatarUrl: DEFAULT_AVATAR_URL,
  socketUrl: SOCKET_URL, 
};
